import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import { setToken } from "./redux/dataSlice";
import { useAuthUserToken } from "./hooks/useAuthUserToken.js";
import SideBar from "./components/SideBar.jsx";
import Footer from "./components/Footer";
import NoPageFound from "./Pages/NoPageFound.jsx";
import LazyRouteHOC from "./utils/LazyRouteHOC.jsx";
import ProtectedRoute from "./utils/ProtectedRoute.jsx";
import Login from "./Pages/Login.jsx";
import Forbidden from "./Pages/Forbidden.jsx";
import {
  clientRoutes,
  platformRoutes,
  commonRoutes,
} from "./Routes/AppRoutes.js";

const renderRoutes = (routes, role) => {
  return routes.map(({ path, element: Element, fallback, requiredPermission }, index) => (
    <Route
      key={index}
      path={`/${path}`}
      element={
        role ? (
          <ProtectedRoute
            element={Element}
            allowedRoles={role}
            requiredPermission={requiredPermission}
          />
        ) : fallback ? (
          <LazyRouteHOC
            component={Element}
            fallback={fallback}
            role={role}
            requiredPermission={requiredPermission}
          />
        ) : (
          <Element />
        )
      }
    />
  ));
};

export default function RouteContainer() {
  const { completeAuthData: authData, rbac } = useAuthUserToken();
  const { role } = authData;
  const { isLoggedIn } = useSelector((state) => state.clientData);
  const [showDash, setShowDash] = useState(true);
  const dispatch = useDispatch();
  const token = process.env.REACT_APP_BASIC_TOKEN;

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    dispatch(setToken({ token: token }));
  }, [dispatch]);
  return isLoggedIn ? (
    <div className="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar">
      <div className="app-main pt-0 flex flex-col min-h-screen">
        <SideBar setShowDash={setShowDash} showDash={showDash} />
        <div className="app-main__outer p-0 h-lvh">
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<Login />} />
            {renderRoutes(commonRoutes, role, rbac)}
            {renderRoutes(platformRoutes, role, rbac)}
            {renderRoutes(clientRoutes, role, rbac)}
            <Route path="*" element={<NoPageFound />} />
            <Route path="/403" element={<Forbidden />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </div>
  ) : (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}
